import { render } from "./GuideToTool.vue?vue&type=template&id=e534464c"
const script = {}

import exportComponent from "C:\\Users\\rebec\\Desktop\\dev\\dma-question-edits\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__